/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Impact_Land_TitleInputs */

const en_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You restored ${i?.number} m² of greenery!`)
};

const ar_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`لقد استعدت ${i?.number} م² من المساحات الخضراء!`)
};

const de_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast ${i?.number} m² Grünfläche wiederhergestellt!`)
};

const es_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¡Has restaurado ${i?.number} m² de vegetación!`)
};

const fr_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous avez restauré ${i?.number} m² d'espaces verts !`)
};

const it_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai ripristinato ${i?.number} m² di verde!`)
};

const ja_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}m²の緑地を復元しました！`)
};

const ko_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}m²의 산림을 복원했어요!`)
};

const pt_br_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você restaurou ${i?.number} m² de área verde!`)
};

const ru_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы восстановили ${i?.number} м² зелени!`)
};

const th_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณได้ฟื้นฟูพื้นที่สีเขียว ${i?.number} ตร.ม.!`)
};

const tr_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} m² yeşil alan restore ettin!`)
};

const zh_cn_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你帮地球复育了 ${i?.number} 平方公尺的绿地！`)
};

const zh_tw_earth_day_2025_impact_land_title = /** @type {(inputs: Earth_Day_2025_Impact_Land_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你幫地球復育了 ${i?.number} 平方公尺的綠地！`)
};

/**
* | output |
* | --- |
* | "You restored {number} m² of greenery!" |
*
* @param {Earth_Day_2025_Impact_Land_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_land_title = /** @type {((inputs: Earth_Day_2025_Impact_Land_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_Land_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_land_title(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_land_title(inputs)
	if (locale === "de") return de_earth_day_2025_impact_land_title(inputs)
	if (locale === "es") return es_earth_day_2025_impact_land_title(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_land_title(inputs)
	if (locale === "it") return it_earth_day_2025_impact_land_title(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_land_title(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_land_title(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_land_title(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_land_title(inputs)
	if (locale === "th") return th_earth_day_2025_impact_land_title(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_land_title(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_land_title(inputs)
	return zh_tw_earth_day_2025_impact_land_title(inputs)
});